import { Injectable } from '@angular/core';
import { TYPE_CART_PURCHARSE } from '../enums/cart.enum';
import {
  AncillariesCartInt,
  AncillaryCartInt,
  BagPassangerInt,
  BookedCartInt,
  CartRequestPNRInt,
  SeatPassanger,
  SegmentChoiceCartInt,
  SegmentsChoicesCartInt
} from '@interfaces/';
import { environment } from '@env/environment';
import { GlobalsService } from './globals.service';
import { GlobalsService as GlobalsServiceMicro } from '@app/services/micro/globals.service';
import { SeatPassangerEstatus, StatusBag } from '@app/enums';
import { PassengerService } from './passenger.service';
import { PassengerService as PassengerServiceMicro } from "@services/micro/passenger.service";
import { Passenger, Reservation } from '@app/models';
import { Passenger as PassengerMicro } from '@app/models/micro/passenger.model';
import { Segment } from '@app/models/cart/segment.model';
import { BagsPassangerInt } from '@app/interfaces/micro/bags.interface';

@Injectable({
  providedIn: 'root'
})

export class CartService {
  url = `${environment.urlApi}`;

  stackBagsToPay: BagPassangerInt[];
  stackBagsToPays: BagsPassangerInt[];
  stackBagsCarryOnExtraWeight: BagPassangerInt[];
  stackSeatsToPay: SeatPassanger[];
  cart: any;
  cartTypeSelect: string;
  bagExtraWeight;
  selectedTrip: Segment;
  typeCartPurcharse: TYPE_CART_PURCHARSE;

  constructor(
    private _globalService: GlobalsService,
    private _globalServiceMicro: GlobalsServiceMicro,
    private _passengerService: PassengerService,
    private _passengerServiceMicro: PassengerServiceMicro,
  ) { }


  private getStackBagsToPay() {
    this.stackBagsToPays = [];
    this._passengerServiceMicro.getPassengerSelection().map(x => {
      this.stackBagsToPays.push(...x.bagStack.filter(y => y.status == StatusBag.TO_PAY))
    });
    return this.stackBagsToPays;
  }

  private getStackBagsToPayCarryOn() {
    this.stackBagsToPay = [];
    this._passengerService.getPassengerSelection().map(x => {
      this.stackBagsToPay.push(...x.bagStackCarryon.filter(y => y.statusBag == StatusBag.TO_PAY))
    });
    return this.stackBagsToPay;
  }

  /* Con la propiedad del sobrePeso, filtrar las maletas para armar el Stack */
  private getStackBagsExtraWeight() {
    let stackBagsExtraWeight = [];
    for (const passenger of this._passengerService.getPassengerSelection()) {
      stackBagsExtraWeight.push(...passenger.bagStack.filter(bag => bag.isExtraWeight && !bag.used));
    }
    return stackBagsExtraWeight;
  }

  private getStackBagsCarryOnExtraWeight() {
    this.stackBagsCarryOnExtraWeight = [];
    for (const passenger of this._passengerService.getPassengerSelection()) {
      this.stackBagsCarryOnExtraWeight.push(
        ...passenger.bagStackCarryon.filter(bag => bag.isExtraWeight && !bag.used)
      );
    }
    return this.stackBagsCarryOnExtraWeight;
  }

  private getStackSeatsToPay() {
    this.stackSeatsToPay = [];
    this._passengerServiceMicro.getPassengerSelection().map((x: PassengerMicro) => {
      const seatsNewPending = x.seatsNew?.filter(y => y.status == SeatPassangerEstatus.PENDING_PAYMENT) || [];
      const seatsPending = x.seats?.filter(y => y.status == SeatPassangerEstatus.PENDING_PAYMENT) || [];
      
      // SOLUCIÓN: Solo tomar seatsNew (asientos recién seleccionados)
      // Ignorar seats (asientos antiguos/previos)
      this.stackSeatsToPay.push(...seatsNewPending);
    });
    
    return this.stackSeatsToPay;
  }

  addItem(item: { type, quantity, subtotal, currencyCode }) {
    this.cart.items.push(item)
  }

  getTypeCartPurchase(): TYPE_CART_PURCHARSE {
    this.typeCartPurcharse = TYPE_CART_PURCHARSE.ONLY_BAGS;
    const hasBagsToPay = this.getStackBagsToPay()?.length > 0;
    const hasBagsToPayCarryOn = this.getStackBagsToPayCarryOn()?.length > 0;
    const hasBagsExtraWeight = this.getStackBagsExtraWeight()?.length > 0;
    const hasBagsCarryOnExtraWeight = this.getStackBagsCarryOnExtraWeight()?.length > 0;
    const hasSeatsToPay = this.getStackSeatsToPay()?.length > 0;

    if (hasBagsToPay && hasSeatsToPay) {
      this.typeCartPurcharse = TYPE_CART_PURCHARSE.SEATS_AND_BAGS
    } else if (hasBagsToPay || hasBagsToPayCarryOn) {
      this.typeCartPurcharse = TYPE_CART_PURCHARSE.ONLY_BAGS
    } else if (hasBagsExtraWeight) {
      this.typeCartPurcharse = TYPE_CART_PURCHARSE.EXTRA_WEIGHT
    } else if (hasBagsCarryOnExtraWeight) {
      this.typeCartPurcharse = TYPE_CART_PURCHARSE.EXTRA_WEIGHT_CARRY_ON
    } else if (hasSeatsToPay) {
      this.typeCartPurcharse = TYPE_CART_PURCHARSE.ONLY_SEATS
    }

    return this.typeCartPurcharse
  }

  /* Eliminar el sobrePeso de las maletas carry On */
  removeStackBagsCarryOnExtraWeight() {
    this.stackBagsCarryOnExtraWeight = [];
    for (const passenger of this._passengerService.getPassengerSelection()) {
      passenger.bagStackCarryon = passenger.bagStackCarryon.filter(bag => bag.isExtraWeight);
    }
  }

  getCart() {
    this.cart = { items: [], total: 0 };
    const bagsToPay = this.getStackBagsToPay();
    const bagsToPayCarryOn = this.getStackBagsToPayCarryOn();
    const bagsExtraWeight = this.getStackBagsExtraWeight();
    const bagsCarryOnExtraWeight = this.getStackBagsCarryOnExtraWeight();

    const seatsToPay = this.getStackSeatsToPay();
    if (bagsToPay?.length > 0) {
      let total = 0;
      this.cart.currencyCode = bagsToPay[0]?.currency?.currencyCode;

      for (const bag of bagsToPay) {
        total += bag?.currency?.total || 0;
      }

      this.addItem({
        type: 'payment.bagsTitle',
        quantity: bagsToPay?.length,
        subtotal: total,
        currencyCode: this.cart.currencyCode
      })
    }
    if (bagsExtraWeight?.length > 0 || bagsToPayCarryOn?.length > 0) {
      let total = 0;
      this.cart.currencyCode = bagsExtraWeight[0]?.currency.currencyCode || bagsToPayCarryOn[0]?.currency?.currencyCode;

      for (const bag of bagsExtraWeight) {
        total += bag?.currency?.total || 0;
      }

      for (const bag of bagsToPayCarryOn) {
        total += bag?.currency?.total || 0;
      }

      this.addItem({
        type: 'payment.bagsWeight',
        quantity: bagsExtraWeight?.length + bagsToPayCarryOn?.length,
        subtotal: total,
        currencyCode: this.cart?.currencyCode
      })
    }

    /*
      Pila de asientos
    */
    if (seatsToPay?.length > 0) {
      let total = 0;
      this.cart.currencyCode = seatsToPay[0]?.currency.currencyCode;

      for (const seat of seatsToPay) {
        total += seat?.currency?.total || 0;
      }

      this.addItem({
        type: 'payment.seat',
        quantity: seatsToPay?.length,
        subtotal: total,
        currencyCode: this.cart?.currencyCode
      })
    }

    this.cart.items.map(x => this.cart.total += x.subtotal);
    return this.cart;
  }

  buildCartInit(): CartRequestPNRInt {
    const bookedCartInts = this._passengerService.getPassengerSelection()?.map(x => {
      const bookedCartInt: BookedCartInt = {
        _meta: {
          class: 'BookedTraveler',
        },
        id: x.id,
        isSelectedToCheckin: true,
        ancillaries: null,
        segmentChoices: null,
      }
      return bookedCartInt;
    });

    let postData: CartRequestPNRInt = {
      cartId: null,
      travelerInfo: {
        _collection: bookedCartInts,
        _meta: { class: 'BookedTravelerCollection' }
      },
      _meta: { class: 'CartPNRUpdate' }
    };
    return postData;
  }

  buildCartBags(): CartRequestPNRInt {
    let { extraBags, carryOn } = this._globalServiceMicro.getAncillaries();
    extraBags = Array.isArray(extraBags) ? extraBags : [];
    carryOn = Array.isArray(carryOn) ? carryOn : [];

    const bookedCartInts = this._passengerServiceMicro.getPassengerSelection().map(passenger => {
      let ancillaries: AncillariesCartInt = { _meta: { class: 'BookedTravelerAncillaryCollection' }, _collection: [] };
      let bags = passenger.bagStack.filter(x => x.status == StatusBag.TO_PAY);
      let bagsCarryOn = passenger.bagStackCarryon.filter(x => x.status == StatusBag.TO_PAY);
      let bagsToExtaWeiht = passenger.bagStack.filter(x => x.isExtraWeight);
      let bagsToExtaWeihtCarryon = passenger.bagStackCarryon.filter(x => x.isExtraWeight);
      let bagsToPay = [...bags, ...bagsCarryOn, ...bagsToExtaWeiht, ...bagsToExtaWeihtCarryon]
      let bagsAncillaries = [...extraBags, ...carryOn]
      let bagsToPnr = [];
      for (let bag of bagsAncillaries) {
        if (!passenger.bagStack.find(x => x.type == bag.type && (x.paid || x.status == StatusBag.REDEEMED_APPLIED)) &&
          !passenger.bagStackCarryon.find(x => x.type == bag.type && (x.paid || x.status == StatusBag.REDEEMED_APPLIED))) {
          bagsToPnr.push(bag);
        }
      }

    for (let extra of bagsToPnr) {
      const bagToPay = bagsToPay.find(x => x.order == extra.order && x.type == extra.type);
      
      const reservation = this._globalServiceMicro.getReservation();
      const firstSegment = reservation?.segments?.[0];
      
      let legCode = '';
      if (firstSegment) {
        const departureDate = firstSegment.departureDateTime?.split('T')[0] || '';
        legCode = `${firstSegment.departureAirport}_${firstSegment.arrivalAirport}_${departureDate}`;
      }
      
      if (!legCode) {
        legCode = reservation?.flightSummary?.legCode || 
                  reservation?.segments?.[0]?.segmentCode || 
                  '';
      }
      const rficSubcode = extra.rficSubcode || bagToPay?.rficSubcode || '0CC';
      const ssrCode = extra.ssrCode || bagToPay?.ssrCode || 'ABAG';
      const emdType = extra.emdType || bagToPay?.emdType || 'A';
      const owningCarrierCode = extra.owningCarrierCode ||
                                bagToPay?.owningCarrierCode ||
                                reservation?.segments?.[0]?.marketingCarrier ||
                                'Y4';
      
      const finalAncillary = {
        ...extra,
        rficSubcode: rficSubcode,
        ssrCode: ssrCode,
        emdType: emdType,
        owningCarrierCode: owningCarrierCode
      };
      
      const ancillariesCartInt: AncillaryCartInt = {
        _meta: { class: 'TravelerAncillary' },
        legCode: legCode,
        quantity: bagToPay ? 1 : 0,
        ancillary: finalAncillary,
      };
      ancillaries._collection.push(ancillariesCartInt);
    }
      const bookedCartInt: BookedCartInt = {
        _meta: {
          class: 'BookedTraveler',
        },
        id: passenger.id,
        isSelectedToCheckin: true,
        ancillaries: ancillaries,
        segmentChoices: null,
      }
      return bookedCartInt;
    });

    let postData: CartRequestPNRInt = {
      cartId: null,
      travelerInfo: {
        _collection: bookedCartInts,
        _meta: { class: 'BookedTravelerCollection' }
      },
      _meta: { class: 'CartPNRUpdate' }
    };
    
    return postData;
  }

  setBagExtraWeight(bag: BagPassangerInt, passenger: Passenger) {
    this.bagExtraWeight = { bag, passenger };
  }

  getBagExtraWeight() {
    return this.bagExtraWeight;
  }

  cleanBagExtraWeight() {
    this.bagExtraWeight.bag.weightDifference = 0;
    this.bagExtraWeight.bag.extraWeight = 0;
  }

  buildCartExtraWeight(reservation: Reservation): CartRequestPNRInt {
    let bookedCartInts = [];
    let ancillaries: AncillariesCartInt = { _meta: { class: 'BookedTravelerAncillaryCollection' }, _collection: [] };
    const ancillariesCartInt: AncillaryCartInt = {
      _meta: { class: 'ExtraWeightAncillary' },
      legCode: reservation.flightSummary.legCode,
      quantity: this.bagExtraWeight.bag.weightDifference,
      ancillary: {
        groupCode: this.bagExtraWeight.bag.groupCode,
        type: this.bagExtraWeight.bag.extraWeightType,

      },
      totalWeight: this.bagExtraWeight.bag.extraWeight,
      weightUnit: 'KG'
    };
    ancillaries._collection.push(ancillariesCartInt);
    const bookedCartInt: BookedCartInt = {
      _meta: {
        class: 'BookedTraveler',
      },
      id: this.bagExtraWeight.passenger.id,
      isSelectedToCheckin: true,
      ancillaries: ancillaries,
      segmentChoices: null,
    }
    bookedCartInts.push(bookedCartInt);

    let postData: CartRequestPNRInt = {
      cartId: null,
      travelerInfo: {
        _collection: bookedCartInts,
        _meta: { class: 'BookedTravelerCollection' }
      },
      _meta: { class: 'CartPNRUpdate' }
    };
    return postData;
  }

  /* Crear Build de sobrePeso en maletas Carry On  */
  buildCarryOnExraWeight(reservation: Reservation): CartRequestPNRInt {
    let { extraBags, carryOn } = this._globalService.getAncillaries();
    const bags = [...extraBags, ...carryOn]
    let ancillaries: AncillariesCartInt = { _meta: { class: 'BookedTravelerAncillaryCollection' }, _collection: [] };
    const bagsCarryOnExtraWeight = this.bagExtraWeight.bag
    for (let extra of bags) {
      const bagExtraCarryOn = extra.type == bagsCarryOnExtraWeight?.type;
      const ancillariesCartInt: AncillaryCartInt = {
        _meta: { class: 'TravelerAncillary' },
        legCode: reservation.flightSummary.legCode,
        quantity: bagExtraCarryOn ? 1 : 0,
        ancillary: extra,
      };

      ancillaries._collection.push(ancillariesCartInt);
    }

    const bookedCartInts: BookedCartInt[] = [{
      _meta: {
        class: 'BookedTraveler',
      },
      id: this.bagExtraWeight.passenger.id,
      isSelectedToCheckin: true,
      ancillaries: ancillaries,
      segmentChoices: null,
    }]

    let postData: CartRequestPNRInt = {
      cartId: null,
      travelerInfo: {
        _collection: bookedCartInts,
        _meta: { class: 'BookedTravelerCollection' }
      },
      _meta: { class: 'CartPNRUpdate' }
    };
    return postData;
  }

  buildCartSeats(idPassenger, reservation, add = true): CartRequestPNRInt {
    const passengers = this._passengerService.getPassengerSelection();
    this.selectedTrip = this._globalService.getSelectedTrip();
    let bookedsCartInts = [];
    for(let passenger of passengers){
      let segmentChoices: SegmentsChoicesCartInt = { _meta: { class: 'BookedSegmentChoiceCollection' }, _collection: [] };
      const seatsToPay = passenger.seats

      for (let seat of seatsToPay) {
        if ((seat.segmentCode == this.selectedTrip.segmentCode) || !add) {
          const segmentChoiceCartInt: SegmentChoiceCartInt = {
            _meta: { class: 'SegmentChoice' },
            segmentCode: seat.segmentCode,
            seatSelectionFee: null,
            seat: {
              _meta: seat._meta,
              code: add ? seat.code : null,
              type: seat?.type,
              currency: seat.currency
            }
          };
          if (seat.status == SeatPassangerEstatus.ASSIGNED || seat.status == SeatPassangerEstatus.NO_ASSIGNED) {
          
            segmentChoiceCartInt.seat._meta = seat._meta
            segmentChoiceCartInt.seat.subjectToSeatSelectionFee = false
            segmentChoiceCartInt.seat.code = seat.code
            segmentChoiceCartInt.seat.currency
          }
          if (seat.status == SeatPassangerEstatus.BENEFIT) {
            segmentChoiceCartInt.seat.code = seat.code
            segmentChoiceCartInt.seat.currency = seat.currency
          }

          segmentChoices._collection.push(segmentChoiceCartInt);
        }
      }
      if (add) {

        segmentChoices = passenger.id == idPassenger ? segmentChoices : null
      }

      const bookedCartInts: BookedCartInt = {
        _meta: {
          class: 'BookedTraveler',
        },
        id: passenger.id,
        isSelectedToCheckin: true,
        ancillaries: null,
        segmentChoices: segmentChoices,
      }

      bookedsCartInts.push(bookedCartInts);
    }

    const cartId = reservation?.flightSummary?.cartId;
    let postData: CartRequestPNRInt = {
      cartId: cartId,
      travelerInfo: {
        _collection: bookedsCartInts,
        _meta: { class: 'BookedTravelerCollection' }
      },
      _meta: { class: 'CartPNRUpdate' }
    };

    return postData;
  }

  buildCartExtraWeight2(): CartRequestPNRInt {
    let reservation = this._globalService.getReservation();
    let bookedCartInts = [];
    this._passengerService.getPassengerSelection().map(passenger => {
      let ancillaries: AncillariesCartInt = { _meta: { class: 'BookedTravelerAncillaryCollection' }, _collection: [] };
      let bagsToExtaWeight = passenger.bagStack.filter(x => x.isExtraWeight && !x.used);
      let bagsToExtaWeightCarryon = passenger.bagStackCarryon.filter(x => x.isExtraWeight && !x.used);
      let bagsToExtraWeight = [...bagsToExtaWeight, ...bagsToExtaWeightCarryon]
      for (let extra of bagsToExtraWeight) {
        const ancillariesCartInt: AncillaryCartInt = {
          _meta: { class: 'ExtraWeightAncillary' },
          legCode: reservation.flightSummary.legCode,
          quantity: extra.weightDifference,
          ancillary: {
            groupCode: extra.groupCode,
            type: extra.extraWeightType,

          },
          totalWeight: extra.extraWeight,
          weightUnit: 'KG'
        };
        ancillaries._collection.push(ancillariesCartInt);
      }
      if (ancillaries._collection.length > 0) {
        const bookedCartInt: BookedCartInt = {
          _meta: {
            class: 'BookedTraveler',
          },
          id: passenger.id,
          isSelectedToCheckin: true,
          ancillaries: ancillaries,
          segmentChoices: null,
        }
        bookedCartInts.push(bookedCartInt);
      }
    });

    let postData: CartRequestPNRInt = {
      cartId: null,
      travelerInfo: {
        _collection: bookedCartInts,
        _meta: { class: 'BookedTravelerCollection' }
      },
      _meta: { class: 'CartPNRUpdate' }
    };
    return postData;
  }

  //Quitar items del carrito
  removeBagsToCart() {
    this.removeStackBagsToPay();
    return this.getCart();
  }

  private removeStackBagsToPay() {
    this.stackBagsToPay = [];
    this._passengerService.getPassengerSelection().map(x => {
      x.bagStack = x.bagStack.filter(y => y.statusBag != StatusBag.TO_PAY)
    });
  }

  removeStackBagsToPayCarryOn() {
    this.stackBagsToPay = [];
    for (const passenger of this._passengerService.getPassengerSelection()) {
      for (const bag of passenger.bagStackCarryon) {
        if (bag.statusBag === StatusBag.TO_PAY) {
          bag.statusBag = StatusBag.INCLUDE;
        }
      }
    }
    return this.getCart();
  }

  removeStackBagsExtraWeight() {
    this.stackBagsToPay = [];
    this._passengerService.getPassengerSelection().map(x => {
      x.bagStack.map(bag => {
        bag.isExtraWeight = false;
        bag.extraWeight = 0;
        bag.weightDifference = 0;
      })
    });
    return this.getCart();
  }

  removeSeatsToCart() {
    //Generacion de buildCart para actualizacion de carrito a nivel de api
    let cartRequest: CartRequestPNRInt;
    cartRequest = this.buildCartSeats(undefined, this._globalService.getReservation(), false);
    //Se quitan los asientos a nivel de memoria para limpiar el carrito
    const passengers = this._passengerService.getPassengerSelection();
    for (const passenger of passengers) {
      passenger.seats = passenger.seats.filter(seat => seat.status !== SeatPassangerEstatus.PENDING_PAYMENT);
    }
    this.stackSeatsToPay = [];
    return cartRequest;
  };
}


